namespace Ir.Components.Workbook.Settings.Items.FontStyleSetting {
    export interface IFontStyleSettingParams {
        label?: string;
        fontBold: KnockoutObservable<boolean>;
        fontItalic: KnockoutObservable<boolean>;
    }
    interface IViewModel {
        buttonGroupOptions: DevExpress.ui.dxButtonGroup.Properties;
        label: string;
    }

    interface IParams {
        config: IFontStyleSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.label = params.config.label ?? "Font Style";

        let fontBold = params.config.fontBold;
        let fontItalic = params.config.fontItalic;

        this.buttonGroupOptions = {
            items: [
                {
                    icon: 'bold',
                    style: 'Bold',
                    hint: 'Bold',
                },
                {
                    icon: 'italic',
                    style: 'Italic',
                    hint: 'Italic'
                }
            ] as any,
            keyExpr: 'style',
            stylingMode: 'outlined',
            selectionMode: 'multiple',
            selectedItemKeys: fontBold() && fontItalic() ? ['Bold', 'Italic'] :
                fontBold() ? ['Bold'] : fontItalic() ? ['Italic'] : [],
            onItemClick: function (e) {
                if (e.itemData.style === 'Bold') {
                    fontBold(!fontBold());
                }
                else if (e.itemData.style === 'Italic') {
                    fontItalic(!fontItalic());
                }
            }
        };
    }
}